<!-- FOR ORDERS PASSED THROUGH -->
<table class="table" *ngIf="order">
    <tbody>
      <tr *ngFor="let item of order.items">
        <td>
          <div [ngClass]="{ refund: item.quantity <= 0 }">{{ item.artist }} {{ item.name }}</div>
          <div *ngFor="let subItem of item.subnames" class="sub-item" [ngClass]="{ refund: item.quantity <= 0 }">{{ subItem.artist }} {{ subItem.name }}</div>
          <div *ngIf="item.sold_price != null && (item.original_price != item.sold_price) && item.quantity > 0" class="coupon-price warn-color">
            {{ ((item.original_price - item.sold_price) * item.quantity) | currency }} Discount
          </div>
        </td>
        <td [ngClass]="{ refund: item.quantity <= 0 }">{{ item.quantity }}</td>
        <td>
          <!-- ACTUAL PRICE -->
          <div *ngIf="item.quantity > 0" [ngClass]="{ strikethrough: (item.sold_price != null) && (item.original_price != item.sold_price) }">
            {{ (item.quantity * item.original_price) | currency }}
          </div>

          <!-- DISCOUNT PRICE -->
          <div *ngIf="item.quantity > 0 && (item.sold_price != null) && (item.original_price != item.sold_price)">
            {{ (item.quantity * item.sold_price) | currency }}
          </div>

          <!-- REFUND -->
          <div *ngIf="item.quantity <= 0" class="warn-color">
            {{ (item.quantity * item.sold_price) | currency}}
          </div>
        </td>
      </tr>

      <tr *ngIf="getDiscount() > 0.02 || getDiscount() < -0.02">
        <td class="warn-color">Discount</td>
        <td class="warn-color"></td>
        <td class="warn-color">{{ getDiscount() | currency }}</td>
      </tr>

      <tr>
        <td>Shipping</td>
        <td></td>
        <td>{{ order.shipping_amount | currency }}</td>
      </tr>

      <tr>
        <td>Tax</td>
        <td></td>
        <td>{{ order.tax_amount | currency }}</td>
      </tr>


      <tr class="total-row light-disabled-background">
        <td>Total</td>
        <td></td>
        <td>{{ order.total_pretax + order.tax_amount + order.shipping_amount | currency }}</td>
      </tr>

      <tr class="disabled-color" *ngFor="let payment of order.paymentMethods">
        <td>{{ payment.refund ? 'Refund' : payment.type }}: {{ payment.amount | currency }}</td>
        <td></td>
        <td>
          <div *ngIf="order.loyaltyPoints">{{ order.loyaltyPoints | number }} Reward Points</div>
        </td>
      </tr>
    </tbody>
  </table>


<!-- FOR THE CURRENT CUSTOMER CART -->
<div class="row" *ngIf="!order && useCart && checkoutDTO">
  <div *ngIf="separate">
    <h4>Items shipping immediately</h4>
  </div>
  <div class="col-12">
    <table class="table">
      <tbody>
        <!-- EACH ITEM -->
        <tr *ngFor="let item of currentCartItems">
          <td>
            <div class="row">
              <div class="col-12 col-sm-3 col-md-2">
                <div>
                  <img class="image" [src]="item.photo.thumbnail_url">
                </div>
              </div>

              <div class="col-12 col-sm-9 col-md-10">
                <!-- ARTIST NAME -->
                <div class="artist-name">{{ item.artistName }}</div>

                <!-- NAME -->
                <div>{{ item.name }}</div>

                <!-- FORMAT -->
                <div *ngIf="item.format && (!item.subnames || !item.subnames.length)">({{ item.format }})</div>

                <!-- BUNDLE SUB-ITEMS -->
                <div *ngFor="let subName of item.subnames" class="sub-item disabled-color">{{ subName }}</div>

                <!-- PRE-ORDER -->
                <div *ngIf="item.preorderDate" class="warn-color">PRE-ORDER: {{ item.preorderDate | date:'longDate':account.timezone_short }}</div>

                <!-- SALE NAME -->
                <div *ngIf="item.saleName" class="coupon-text warn-color">
                  {{ item.saleName }}
                </div>

                <!-- COUPON NAME -->
                <div *ngIf="(item.price != item.originalPrice) && item.couponName" class="coupon-text warn-color">
                  Coupon applied
                </div>

                <!-- COUPON DISCOUNT -->
                <div *ngIf="item.price != item.originalPrice" class="coupon-price warn-color">
                  You saved {{ (item.originalPrice - item.price) * item.quantity | currency }}!
                </div>
              </div>
            </div>
          </td>

          <td>{{ item.quantity }}</td>

          <td class="currency">
            <div class="original-price disabled-color" *ngIf="item.originalPrice != item.price">{{ item.originalPrice * item.quantity | currency }}</div>
            <div class="price">{{ item.price * item.quantity | currency }}</div>
          </td>
        </tr>

        <!-- EACH BONUS ITEM -->
        <tr *ngFor="let item of checkoutDTO.cart.bonus" class="lightest-accent-background">
          <td>
            <div class="row">
              <div class="col-12 col-sm-3 col-md-2">
                <div>
                  <img class="image" [src]="item.photo.thumbnail_url">
                </div>
              </div>
              <div class="col-12 col-sm-9 col-md-10">
                <div class="artist-name">{{ item.artistName }}</div>
                <div>{{item.name}} <span *ngIf="item.format">({{item.format}})</span> </div>
                <div class="coupon-text accent-color">{{item.saleName}}</div>
              </div>
            </div>
          </td>
          <td>{{item.quantity}}</td>
          <td class="currency">{{item.price | currency}}</td>
        </tr>



        <!-- COUPON -->
        <tr *ngIf="couponDiscount && couponCode" class="coupon-discount warn-color">
          <td>{{ couponCode }}</td>
          <td></td>
          <td class="currency">{{ (couponDiscount * -1 | currency) || '-' }}</td>
        </tr>

        <!-- Items -->
        <tr class="hard-border">
          <td>Sub Total</td>
          <td></td>
          <td class="currency">{{ (totalPretax | currency) || '-' }}</td>
        </tr>

        <!-- SHIPPING -->
        <tr>
          <td><div>Shipping</div> <div *ngIf="shippingName" class="shipping-name">{{shippingName}}</div></td>
          <td></td>
          <td class="currency">{{ (shippingRate | currency) || '-' }}</td>
        </tr>

        <!-- TAX -->
        <tr>
          <td>Tax</td>
          <td></td>
          <td class="currency">{{ taxAmount | currency }}</td>
        </tr>

        <!-- TOTAL -->
        <tr [ngClass]="{ 'total-row': grandTotal == total }" *ngIf="!useCredits">
          <td>Total</td>
          <td></td>
          <td class="currency">{{ total | currency }}</td>
        </tr>


        <!-- CREDITS -->
        <tr *ngIf="availableCredits">
          <!-- ASK TO USE CREDITS -->
          <td *ngIf="!useCredits" (click)="toggleCredits()">
            <input type="checkbox" [checked]="useCredits">&nbsp;&nbsp; I'd like to apply my {{ allowedCredits | currency }} gift card (of {{ availableCredits | currency }} available) to this order
          </td>

          <!-- USING CREDITS -->
          <td *ngIf="useCredits" (click)="toggleCredits()">
            <input type="checkbox" [checked]="useCredits">&nbsp;&nbsp; Credit Applied
          </td>
          <td></td>
          <td class="currency">{{ useCredits ? (-1 * creditAmount | currency) : '-' }}</td>
        </tr>

        <!-- TOTAL -->
        <tr class="total-row" *ngIf="grandTotal != total">
          <td>Order Total</td>
          <td></td>
          <td class="currency">{{ grandTotal | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="col-12">
    <div class="credit-code">
      <pv-coupon></pv-coupon>
    </div>

    <div class="credit-code">
      <pv-credits [checkout]="true" (onRedeem)="onRedeem()"></pv-credits>
    </div>
  </div>
</div>
